import { useTheme } from 'styled-components'

import { IconBase, IconProps } from './Base'

export const IconSearch = (props: IconProps) => {
  const theme = useTheme()

  return (
    <IconBase width={props.width || 24} height={props.height || 24} viewBox="0 0 24 24" fill="none" style={props.style}>
      <path
        d="M11 19C15.4183 19 19 15.4183 19 11C19 6.58172 15.4183 3 11 3C6.58172 3 3 6.58172 3 11C3 15.4183 6.58172 19 11 19Z"
        stroke={theme.colors.text.primary}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21 21L16.7 16.7"
        stroke={theme.colors.text.primary}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </IconBase>
  )
}
